var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"25","height":"14","viewBox":"0 0 25 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"24.0263","height":"2","fill":"#444444"}}),_c('rect',{attrs:{"y":"6","width":"24.0263","height":"2","fill":"#444444"}}),_c('rect',{attrs:{"y":"12","width":"24.0263","height":"2","fill":"#444444"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }